import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../../components/global/modal/withModal';
import Button from '../../../../../../../../components/global/Button';

const propTypes = {
  onClose: PropTypes.func.isRequired,
};

const ImportInstructionsModal = ({ onClose }) => {
  return (
    <div>
      <p>
        Upload a spreadsheet or CSV that contains a list of data (your
        contacts). When importing, make sure that every piece of information has
        its own unique column in that import file. Your Waldo address book
        expects the data to be structured in the following way:
      </p>

      <table className="table table-csv-sample">
        <caption>
          Columns in <span className="text-primary">blue</span> are{' '}
          <em>required</em>.
        </caption>

        <thead className="pb-1">
          <tr>
            <th className="required">First name</th>
            <th className="required">Last name</th>
            <th className="required">Mobile phone</th>
            <th>Birth date</th>
            <th className="required">Address line 1</th>
            <th className="required">City</th>
            <th className="required">State</th>
            <th className="required">Zip code</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Jane</td>
            <td>Doe</td>
            <td>12695357269</td>
            <td>1984-12-24</td>
            <td>4237 Garrett Street</td>
            <td>New York</td>
            <td>NY</td>
            <td>49093</td>
          </tr>

          <tr>
            <td>Brad</td>
            <td>Peters</td>
            <td>19897990743</td>
            <td />
            <td>1415 Juniper Dr.</td>
            <td>Saginaw</td>
            <td>MI</td>
            <td>49093</td>
          </tr>

          <tr className="pt-1">
            <td colSpan="9">etc&hellip;</td>
          </tr>
        </tbody>
      </table>

      <p className="text-extra-bold mb-1 text-sm">
        Accepted files &amp; sample spreadsheet:
      </p>
      <p className="text-sm">
        Accepted file formats are <code>.xls</code>, <code>.xlsx</code>, and{' '}
        <code>.csv</code>. Download a{' '}
        <a
          href="https://d1ldwnjkukjs70.cloudfront.net/waldo-contacts-template.xlsx"
          download
        >
          sample spreadsheet template here
        </a>
        .
      </p>

      <p className="text-extra-bold mb-1 text-sm">Linking identities:</p>
      <p className="text-sm">
        If first name, last name, and mobile phone match with anyone joined to
        your galleries, your contact will automatically be linked to it and you
        will have access to all their matched photos and favorites.
      </p>

      <p className="text-extra-bold mb-1 text-sm">
        Linking contacts to galleries:
      </p>
      <p className="text-sm">
        It is possible during import to link the contacts to a specific gallery
        or a set of albums. Doing so will keep your contacts organized and allow
        you to filter them easily. Linked contacts will not be joined to the
        gallery member list.
      </p>
      <p className="text-extra-bold mb-1 text-sm">
        Importing multiple emails or phone numbers for a single ID:
      </p>
      <p className="text-sm">
        If you have multiple email addresses or phone numbers for a single
        person, you can list these out, separated by space in a single cell, in
        order for all info to be tied to a single line via the Members tab.
      </p>

      <div className="row">
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Required fields:</p>
          <p className="text-sm">
            First name, Last name, Mobile phone, and address fields are required
            data fields for every contact. All fields are editable after the
            import.
          </p>
        </div>
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Optional fields:</p>
          <p className="text-sm">
            You can skip optional data by leaving their values empty.
          </p>
        </div>
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Mobile phone numbers:</p>
          <p className="text-sm">
            All mobile phone numbers must have the country suffix prepended (1
            for the USA), i.e. formatted according to the{' '}
            <a
              href="https://en.wikipedia.org/wiki/E.164"
              target="_blank"
              rel="noopener noreferrer"
            >
              E.164 standard format
            </a>
            .
          </p>
        </div>
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Birth date:</p>
          <p className="text-sm">
            The birth date (if provided) should be in the following format:{' '}
            <code>YYYY-MM-DD</code>, where <code>&rdquo;Y&ldquo;</code> stands
            for Year,
            <code>&rdquo;M&ldquo;</code> for Month, and{' '}
            <code>&rdquo;D&ldquo;</code> for Day. If you import a spreadsheet
            usually this is already taken care of automatically by the file
            itself.
          </p>
        </div>
      </div>

      <div className="text-center">
        <Button onClick={onClose} btnStyle="link" className="mt-3">
          Dismiss
        </Button>
      </div>
    </div>
  );
};

ImportInstructionsModal.propTypes = propTypes;

export default withModal(ImportInstructionsModal, {
  contentLabel: 'Importing Instructions',
  size: 'md',
});
